import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  dueDate: "",
};
const getValueToShortcutKey = (state, data) => {
  let todayDate = new Date();
  let event = data.event;
  let refs = data.refs;
  let screenName = data.screen;
  let charCode = String.fromCharCode(event.which).toLowerCase();
  switch (charCode) {
    case "g": //go button
      refs.nextRef && refs.nextRef.current.click();
      break;
    case "e": //view
      refs.viewRef && refs.viewRef.current.click();
      break;
    case "m": //modify
      refs.modifyRef && refs.modifyRef.current.click();
      break;
    case "j":
      refs.downloadRef && refs.downloadRef.current.click();
      refs.downloadCopyRef && refs.downloadCopyRef.current.click();
      refs.downloadTemplateRef && refs.downloadTemplateRef.current.click();
      refs.downloadBulkRef && refs.downloadBulkRef.current.click();
      break;
    case "u":
      if (
        screenName === "journalDetail" ||
        screenName === "disbursementCreate" ||
        screenName === "disbursementModify"
      ) {
        refs.approveRef && refs.approveRef.current.click();
      } else {
        refs.uploadRef && refs.uploadRef.current.click();
        refs.uploadCopyRef && refs.uploadCopyRef.current.click();
        refs.uploadTemplateRef && refs.uploadTemplateRef.current.click();
        refs.uploadBulkRef && refs.uploadBulkRef.current.click();
      }
      break;
    case "b":
      refs.deleteRef && refs.deleteRef.current.click();
      break;
    case "a":
      // refs.addRowRef && refs.addRowRef.current.click();
      refs.addRowRef && refs.addRowRef.current.click();
      break;
    case "k": //ok button click in nach mandate & nach inward &nach activate
      refs.okRef && refs.okRef.current.click();
      refs.okInfoRef && refs.okInfoRef.current.click();
      refs.okValRef && refs.okValRef.current.click();
      refs.okEditRef && refs.okEditRef.current.click();
      refs.okUMRef && refs.okUMRef.current.click();
      refs.bankDetailOkRef && refs.bankDetailOkRef.current.click(); //payment dialog
      refs.validationDialogOkRef && refs.validationDialogOkRef.current.click(); //payment dialog
      refs.informationDialogOkRef &&
        refs.informationDialogOkRef.current.click(); //payment dialog

      break;
    case "y":
      refs.yesRef !== null && refs.yesRef.current.click();
      break;
    case "q": //nach verification submit cancel button
      refs.cancelRef !== null &&
        refs.cancelRef &&
        refs.cancelRef.current !== null &&
        refs.cancelRef.current.click();
      refs.cancelResetRef && refs.cancelResetRef.current.click();
      refs.closeRef && refs.closeRef.current.click();
      refs.closeFileRef && refs.closeFileRef.current.click();
      break;
    case "s":
      refs.saveCopyRef && refs.saveCopyRef.current.click();
      refs.saveRef && refs.saveRef.current.click();
      break;
    case "d":
      refs.clearRef && refs.clearRef.current.click();
      refs.clearCopyRef && refs.clearCopyRef.current.click();

      break;
    case "r":
      if (
        screenName === "disbursementCreate" ||
        screenName === "journalCreate" ||
        screenName === "journalDetail"
      ) {
        refs.deleteRowRef !== null && refs.deleteRowRef.link.current.click();
      } else {
        //  refs.detailRef && refs.detailRef.current.click();
      }

      break;
    case "f":
      refs.searchButtonRef && refs.searchButtonRef.current.click();
      break;
    case "h":
      refs.historyRef && refs.historyRef.current.click();
      break;
    case "z":
      refs.backRef && refs.backRef.current.click();
      break;
    case "i":
      state.dueDate = todayDate;
      break;

    case "p":
      todayDate.setDate(todayDate.getDate() + 1);
      state.dueDate = todayDate;
      break;
    case "o":
      todayDate.setDate(todayDate.getDate() - 1);
      state.dueDate = todayDate;
      break;

    default:
      break;
  }
};
const removeDefaultshortCutKey = (data) => {
  let event = data.event;
  let screenName = data.screen;
  let charCode = String.fromCharCode(event.which).toLowerCase();

  if (event.ctrlKey) {
    switch (charCode) {
      case "e":
        if (
          screenName === "moreAction" ||
          screenName === "nachApproval" ||
          screenName === "journalDetail" ||
          screenName === "basicReceipt" ||
          screenName === "paymentDetailFilter" ||
          screenName === "securityFilter" ||
          screenName === "disbursementLoadActionBtn"
        ) {
          event.preventDefault();
        }
        break;
      case "f":
        if (
          screenName === "accuralWaiver" ||
          screenName === "additionalAccrual" ||
          screenName === "disbursement" ||
          screenName === "nachFilter" ||
          screenName === "nachApproval" ||
          screenName === "nachRetrieval" ||
          screenName === "journalCreate" ||
          screenName === "basicReceipt" ||
          screenName === "filePaymentFilter" ||
          screenName === "paymentDetailFilter" ||
          screenName === "chequeReturnFilter" ||
          screenName === "mandateReturnFilter" ||
          screenName === "cashHandlingCharge" ||
          screenName === "prePaymenthandling" ||
          screenName === "listOfValue" ||
          screenName === "specialAcess" ||
          screenName === "settlementFigure" ||
          screenName === "loanClosureFilter" ||
          screenName === "securityFilter" ||
          screenName === "covFilter" ||
          screenName === "receiptDetails" ||
          screenName === "returnDetails" ||
          screenName === "voucherDetails" ||
          screenName === "disbursementCreate" ||
          screenName === "filterCondition" ||
          screenName === "basicReceipt" ||
          screenName === "parameter" ||
          screenName === "disbursementRequestList"
        ) {
          event.preventDefault();
        }
        break;
      case "a":
        if (
          screenName === "disbursementCreate" ||
          screenName === "nachFilter" ||
          screenName === "journalCreate" ||
          screenName === "journalDetail" ||
          screenName === "creditAmount" ||
          screenName === "filePaymentDetail" ||
          screenName === "paymentModeDetail" ||
          screenName === "chequeReturnFilter" ||
          screenName === "mandateReturnFilter" ||
          screenName === "cashHandlingCharge" ||
          screenName === "prePaymenthandling" ||
          screenName === "listOfValue"
        ) {
          event.preventDefault();
        }
        break;
      case "d":
        if (
          screenName === "disbursementCreate" ||
          screenName === "nachFilter" ||
          screenName === "accuralWaiver" ||
          screenName === "additionalAccrual" ||
          screenName === "nachVerification" ||
          screenName === "nachApproval" ||
          screenName === "nachRetrieval" ||
          screenName === "journalCreate" ||
          screenName === "journalDetail" ||
          screenName === "basicReceipt" ||
          screenName === "filePaymentFilter" ||
          screenName === "paymentDetailFilter" ||
          screenName === "chequeReturnFilter" ||
          screenName === "mandateReturnFilter" ||
          screenName === "cashHandlingCharge" ||
          screenName === "prePaymenthandling" ||
          screenName === "listOfValue" ||
          screenName === "specialAcess" ||
          screenName === "settlementFigure" ||
          screenName === "repaymentStructure" ||
          screenName === "loanClosureFilter" ||
          screenName === "reSchedulement" ||
          screenName === "securityFilter" ||
          screenName === "covFilter" ||
          screenName === "receiptDetails" ||
          screenName === "returnDetails" ||
          screenName === "voucherDetails" ||
          screenName === "filterCondition" ||
          screenName === "disbursementRequestList"
        ) {
          event.preventDefault();
        }
        break;
      case "c":
        //  event.preventDefault();

        break;
      case "u":
        if (
          screenName === "nachInward" ||
          screenName === "nachExclude" ||
          screenName === "paymentDetailFilter" ||
          screenName === "journalDetail" ||
          screenName === "bulkReturn" ||
          screenName === "specialAcess" ||
          screenName === "disbursementModify"
        ) {
          event.preventDefault();
        }
        break;
      case "r":
        if (screenName === "securityFilter" || screenName === "covFilter") {
          event.preventDefault();
        }
        break;
      case "b":
      case "y":
      case "s":
      case "o":
      case "w": //

      case "j":

      case "g":

      case "p":
      case "k":
      case "l":
      case "n":
      case "e":
      case "t": //
      case "h":
      case "z":
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
      case "10":
        event.preventDefault();
        break;
      default:
        break;
    }
  } else {
    if (event.keyCode > 111) {
      event.preventDefault();
    }
  }
};
const CommonShortCutReducer = createSlice({
  name: "shortcuts",
  initialState: initialState,
  reducers: {
    getShortCutValue(state, action) {
      getValueToShortcutKey(state, action.payload);
    },
    removeDefaultShortCutValue(state, action) {
      removeDefaultshortCutKey(action.payload);
    },
  },
});
export const CommonShortCutAction = CommonShortCutReducer.actions;
export default CommonShortCutReducer.reducer;
